// prettier-ignore
export default {
  generic: {
    network_error: '연결할 수 없습니다.<br>인터넷 연결을 확인하세요.',
    network_restored: '인터넷 연결이 복원되었습니다',
    bluetooth_error: '블루투스 연결이 해제되었습니다.<br>장치를 가까이 두고 측정 과정에서 신호가 충분히 강한지 확인하십시오',
    permisson_device_orientation_not_allowed: '방향 센서 기능을 사용하려면 브라우저를 다시 시작하여 권한을 다시 요청하는 것이 좋습니다.<br>또는 핸드폰을 지면과 수직으로 만든 후 다음을 클릭하십시오.',
    permisson_device_orientation_not_support: '죄송합니다만, 귀하의 브라우저는 방향 센서 기능을 지원하지 않습니다. 다른 브라우저나 기기를 시도하거나,<br>핸드폰을 지면과 수직으로 만든 후 다음을 클릭하십시오.',
  },
  terms: {
    terms: 'Cloudzet™ Body Scanning Service (“Service”) is provided by TG3D Studio Inc. Limited and its Affiliates (“TG3D,” “We,” or “us”) under this Terms of Use (the “Terms”). <br><br>When you register the Service, you agree that you have read, understood, and consented to all the content stated in the Terms. If you are a minor, you should make sure your parents (or guardians) read, understand and agree you to comply with the Terms in full before you start using this Service. We reserve the right to modify or amend the Terms. Please visit the Terms from time to time. Your continued use of the Service after any such modification or amendment constitutes your or your parent’s (or guardian’s) acceptance of the new Terms. <br><br>Service <br><br>The Body Measurements and 3D body shape model of the User (collectively,  3D body measurements file) can be scanned and  generated by Cloudzet™ App and the Scanatic 360 Body Scanner.  When User uses the Service in the Third-party Store,  User’s 3D body measurements file is accessible by the Third-party Store for providing the custom-made clothing service and (or) recommendation service of branded clothes  to the User. Also, we will recommend personalized branded clothes to the User. The custom-made clothing service and any branded clothes are provided by the Third-party Store and clothing company, the User should review the pattern, fabric, size, cutting and the delivery of the ordered clothes carefully. <br><br>2. Definition <br><br>Software means the Cloudzet™ App developed by us and/or our affiliates, including, but not limited to, all updated versions, any supplemental and/or external apps and/or software subsequently provided by us. <br><br>User means a user who has completed the membership registration process. (“User”or “you”) <br><br>3D body measurements file means the electronic record containing the information of 3D body shape model and the Body Measurements. <br><br>3D body shape model  means the raw data of body shape shown in 3D format generated in the Service. <br><br>Body Measurements means the User’s body measurements, including but not limited to, Neck circumference, bust, waist and hips, generated in the Service <br><br>Third-party store means the third party company (including its websites and Apps) proving the service of custom-made clothing and the sales of the clothing in the Service. <br><br>3. Registration <br><br>User shall provide mobile number or email and any required information (e.g. name and gender) to complete the registration process. <br><br>User may log in the Service by connecting to your personal account of certain third party social network sites, including but not limited to, Facebook or Weixin. <br><br>4. User’s duty and Obligation <br><br>You agree to provide accurate, complete and true personal information for registration, and you may update such information online at any time. If you provide incorrect or misleading personal information that cause damages to damages to the rights or interests of other users or third parties, we may terminate your user account and use of Services, and you shall be solely responsible for the relevant legal liabilities and/or damages. <br><br>User shall further fulfill the following obligation to secure user account.  <br><br>User account shall be used by User only. You shall only use our Services and Software in accordance with the Terms and shall not allow any third party to access the Services and Software by logging in your user account. <br><br>You are obliged to properly safeguard your user account details, passwords and other relevant information. You shall be fully liable for any and all acts and/or activities, including all related fees, carried out under your user account. <br><br>If you discover any unauthorized use or unusual access to your user account, you should report to us immediately and protect your personal interests through appropriate legal means. If necessary, we will ask you to provide the relevant personal information and have the right to take charge of the account in dispute. <br><br>If unlawful use of user account and passwords is caused by your negligence or third parties’ use of the accounts with your consent, and causes damages to the interests of us or other users, you shall be solely responsible for the relevant legal liabilities and/or damages. <br><br>5. Collection of your information <br><br>Your use of the Service constitutes your consent to the collection, processing and use of your personal information, 3D body model shape and Body Measurements through the Service by TG3D for provide you the Service. <br><br>Restriction <br><br>Subject to your continuous compliance of this Terms and the additional terms and conditions imposed by the relevant Software and Services, you are authorized to use our Services and Software. If we are aware of any breach, we may suspend or terminate your right to use the Software and Services. <br><br>You are authorized to use Software and Service, but you are not allowed to modify, sub-license, lease, sell or assign any of the rights granted under the Terms. You also agree to comply with all relevant laws and regulations and use the Software and Services for lawful purposes only. <br><br>You are only authorized to use the Software. The intellectual property rights of all Software and relevant program codes are owned by us. You are prohibited from modifying, reverse engineering, reverse coding, decompiling (into a human readable format) or dissembling the Software, impeding or interfering with other user’s use of the Software and Services, or disseminating through the Software and Services virus or other malwares which are harmful to the others’ computer operation, software or contents which are in breach of the Terms and any content which may infringe the others’ intellectual property rights or other rights. <br><br>We will take all necessary steps to prevent you from using the Software and/or Services in a manner which is in breach of the Terms or the relevant laws and regulations. <br><br>7. Privacy Policy <br><br>Please refer to the Privacy Policy. <br><br>8. Intellectual Property <br><br>You are only authorized to use the Services and Software, and do not acquire from us the copyright, trademark, patent and/or any other proprietary right in the Services and Software, and any program codes provided by us. For the avoidance of doubt, all rights are reserved by us unless expressly granted to you under the Terms. <br><br>You acknowledge that our Services, Software and technology are protected by the relevant laws of their respective licensed territories and agree not to remove or modify any digital right management information, anti-piracy measures or symbols of other rights (including but not limited to patent right and trade mark right) or software, which are contained in the Services and Software. <br><br>9. Limited liability <br><br>Any information, content, software or services provided by us through Software and/or Services will be provided AS IS at the time of provision. We do not guarantee or warrant the format and content of our Services in the event of Internet connection failure, delay or other relevant communication defect. <br><br>Unless otherwise expressly stated in the law, in no event, shall we and/or our authorized agents be liable for any loss or damages, including losses caused by the use of Software and/or Services, the failure to use Software and/or Services, and/or other direct, indirect, accidental, special or consequential losses, including but not limited to loss of business profits, business loss, business interruption, business information loss and any other monetary loss. <br><br>We will not warrant and be liable for any damages or defects arising out of any and all disputes between you and the Third-party Store or any and all intentional or negligent act of other users. <br><br>Any dispute arising out of or in connection with the transaction between User and the Third-party Store or any clothing company shall be solved by the User and Third-party Store or clothing company. TG3D is not liable for any damages or defects arising out of or in connection with such disputes. <br><br>10. Amendment <br><br>We reserve the right to amend the Terms from time to time. You will be deemed to have accepted the amendments when you continue to use our Software and Services after we announce the amended Terms on our website or APP. <br><br>11. Laws and Jurisdiction <br><br>The Terms shall be construed, supplemented and applied in accordance with the laws of the Republic of China. For any matter which is not covered herein, please contact our customer service. Both parties agree that all disputes arising out of the Terms shall be subject to the jurisdiction of the Taiwan Taipei District Court if they cannot be resolved through negotiation and the parties have to resort to litigation.',
    privacy: "TG3D Studio Inc. Limited and its affiliates (“We”) take your personal privacy seriously and duly comply with the relevant privacy and personal information protection laws and regulations. Our Privacy Policy (the “Policy”), which explains what personal information we collect and how to use such data, as well as other important matters related to your privacy, is set out as the following. <br><br>When you register as a User of Cloudzet™ App (the “Service”), you will be required to enter certain information, including, but not limited to, an account ID (mobile number or email address), name, gender and date of birth. <br><br>If you connect your account via Facebook, WeChat or other services (“Third Party Service”), you agree us to collect your personal verification information and other data that may be accessible from your Third Party Service account, including your name, profile photos, country, email address, date of birth, gender, names of friends, and other personal pictures and social network. We may verify whether your data matches those collected from such Third Party Service and will store and use such data pursuant to the Policy. <br><br>When you use the Service, we may collect the following information：  <br><br>your body measurements, 3D body shape model, height, weight location information and address; <br><br>information about your use of the Service, include camera, photos and the information stored in the SD card; and <br><br>technical information, such as URL, IP address,web browser type , operation system of your device, language, and the time of visit. We employ Google Analytics to collect the aforementioned information. You could find more information about the privacy policy of Google Analytics and how to disable Google Analytics by visiting Google’s Data privacy and security. You could disable Google Analytics by downloading and installing Google Analytics Opt-out Browser Add-on. <br><br>To properly and promptly provide you with the Service, you will be required to provide the user account and the contact information when you use the Service, including but not limited to, procurement, changing the information of user account, feedback or participating in any promotional activities. <br><br>The information we collected will be used as the following: <br><br>The basic personal information you provide (such as your name) will be used for the purpose of User identification for TG3D and the Third-party store; the contact information you provide may be used for contacting you, notifying you promotional events, payment reminder, award notice, payment receipt notice, sending invoices, branded clothes recommendation and/or other update notices related to the Service. If you do not want to receive any promotional email or text message, please contact support@tg3ds.com. <br><br>Your 3D body shape model and Body Measurements will be used for providing you ,  and the service of made-to-measure,, bespoke and the recommendation of brand clothes by the Third-party Store and the recommendation service of personalized branded clothes from us. <br><br>Information about your use and technical data and 3D body measurements file generated etc. from your use of this Service may be used for improving the Service, and/or developing new services. <br><br>We will provide you for ours or any third party’s promotional information and advertisement from time to time by push notification. If you no longer wish to receive these types of communications, or if you've initially agreed for the application to access your camera, photo and SD card and you would like to stop the app from accessing them, you may turn them off at the device level. <br><br>You understand and agree that we may share with third parties the data which  is not able to reflect or specify any identifiable individual.  <br><br>The data collected herein may be processed and/or used by our affiliates or partners or outside Taiwan. We will not use them for any other purposes unless the local laws provide otherwise, and will also not disclose them to any third party without your prior consent, unless the laws require so due to material national interests or for the purpose of facilitating law enforcement agencies’ investigations. <br><br>You may search, copy or change your own personal Information. If you are not our User or we have not yet verified your membership, you are not allowed to search, copy, request for review or change the user’s personal information and account services of our accounts. For requests made in circumstances other than above, you would be required to provide your relevant personal information and written documentation as may be necessary to enable us to process your request. <br><br>You may request the use of your personal information be suspended or your own personal information be deleted.  However, once the use is suspended or personal information is deleted, you will no longer be able to use the Service. You may exercise your right to portability to obtain a copy of  your personal data provided to us. You may object to process the processing of your personal data and withdraw your consent to processing for marketing and profiling. you can always exercise your rights described above by sending a written request to us at the following address: support@tg3ds.com <br><br>You grant us an irrevocable right to use the data which is not able to reflect or specify any identifiable individual for the improvement of the Service and relevant technology and the development of the new service. <br><br>We are entitled to refuse your request to change, delete or modify your personal information if such request may be harmful to the material national interests, result in impediment to the execution of statutory duties by government agencies, or cause any prejudice to the material interests of the collecting agency or third party. <br><br>We will provide all necessary technologies and measures to protect your personal information in order to safeguard your privacy. <br><br>To avoid information leakage, you should keep your own personal information, user account and password, etc. in safe custody. To avoid misuse of your personal information, you should log out or close the software or internet browser after using the Services, whether you are using your own personal computer or not. <br><br>You should keep your payment information (including credit card details) in safe custody to avoid being used by others for illegal purpose. <br><br>The Service may include hyperlinks to third parties’ websites or web pages. We are not held jointly liable if you agree to allow those websites to collect, process, and/or use your personal information. <br><br>You agree to use true and accurate information for purchases on the Service. You should notify us immediately if you find your personal information has been misused by others or if you find something abnormal. <br><br>You agree to provide and use lawful information when using the Services and all such information does not infringe any third party’s rights, violate any third party’s agreement or otherwise involve any illegal acts. If use of the Services causes any third party’s loss, we are not liable for such loss unless it is caused by us intentionally or due to our gross negligence. <br><br>We may update this Policy from time to time and comply with the relevant local privacy laws and regulations. When we make significant changes, we will make an announcement on our official website(http://www.tg3ds.com) or APP. <br><br>This Policy constitutes part of the Terms of Service. If you do not agree any part of this Policy or any amended content, please stop using the Service immediately. <br><br>If you have any question regarding the Policy, please contact us at support@tg3ds.com",
  },
  login: {
    cloudzet_welcome: '안녕하세요, Cloudzet에 오신 것을 환영합니다.',
    mtm_username: 'Scanatic™ 계정',
    password: '비밀번호',
    login: '로그인',
    logging_in: '로그인 중...',
    no_login_methods: '이 Scanatic™ 계정에 대해 설정된 로그인 방법이 없습니다.',
    agreements_button: '동의 및 계속',
    complete_email_reset_pwd_title: '우리에게 맡겨!',
    sent_email: '비밀번호 변경 확인 메일를 다음 주소로 보냈습니다.',
    email_reset_pwd: '지침에 따라 비밀번호를 재설정하세요.',
    get_the_code: '인증 코드를 받지 못하셨나요?',
    resend: '재전송',
    complete_phone_reset_pwd_title: '축하합니다!',
    login_new_password: '새 비밀번호가 설정되었습니다.<br />새 비밀번호로 로그인하십시오.',
    login_my_account: '내 계정에 로그인',
    sent_a_code: '인증 코드를 다음으로 전송했습니다.',
    received_code: '받으셨다면 알려주세요',
    verification_code_error: '인증 코드 오류',
    continue: '계속',
    forget_your_password: '비밀번호를 잊어 버리 셨나요?',
    forget_password_text: '괜찮아요!',
    send: '전송',
    submit: '보내기',
    no_such_user: '계정을 찾지 못했습니다',
    email_prompt_text: '비밀번호 재설정 이메일을 보내드립니다',
    phone_prompt_text: '4자리 인증 코드를 보내드립니다',
    login_title: '다시 오신 것을 환영합니다!',
    login_email_title: '이메일로 로그인',
    login_phone_title: '전화로 로그인',
    forget_password: '비밀번호를 잊어 버리 셨나요?',
    terms_of_service: '서비스 약관',
    choose_a_country_code: '국가 코드 선택',
    choose_a_country_code_hint: '	로그인/등록은 다음 국가 및 지역에서만 가능합니다.',
    country_code_not_found: '국가 코드를 찾을 수 없나요?',
    sign_up_email: '이메일로 가입',
    email_sign_up_error_msg: '정확한 이메일을 입력해주세요',
    four_characters: '비밀번호는 4자 이상이어야 합니다',
    try_to_login: '이 계정은 이미 존재합니다. 로그인 시도',
    try_use_email: '이메일을 사용해 보세요',
    sign_up: '가입하기',
    sent_verification_code: '4자리 인증 코드를 보내드립니다.',
    sign_up_phone: '전화로 가입',
    sign_up_store: '회원가입',
    set_up_new_pwd: '이제 새 비밀번호를 설정하세요.',
    set_up_new_password: '이제 새 비밀번호를<br> 설정할 수 있습니다.',
    set_new_pwd: '새 비밀번호 설정',
    enter_country_code: '국가 코드 입력',
    enter_email_address: '이메일 주소를 입력하세요',
    enter_phone_number: '전화번호를 입력하세요',
    customer_account_name: '고객 계정 이름',
    enter_password: '암호 입력',
    re_enter_password: '비밀번호 재입력',
    login_social_accounts: '소셜 계정으로 가입',
    social_login_failed: '소셜 계정으로 로그인하지 못했습니다',
    login_first: '먼저 로그인하시기 바랍니다',
    create_with_store: '회원가입',
    verify: '확인',
    welcome_to_store: '{storeName}에 오신 것을 환영합니다!',
    login_to_continue: '계속하려면 로그인/가입하세요',
    wrong_password: '잘못된 비밀번호입니다. 다시 입력해 주세요.',
  },
  welcome: {
    enable_bt: '계속하기 전에 블루투스를 켜주세요',
    welcome_title: '3D 인체측정실에 오신 것을 환영합니다',
    welcome_tagline: '',
    powered_by: 'TG3D Studio Inc. 제공',
    tap_to_start: '버튼을 클릭하여 3D 측정을 시작합니다',
    tap_camera_on: '카메라 렌즈를 켜서 QR 코드를 스캔하세요.',
    ready_to_scan_qr: 'QR 코드 스캔 준비 완료',
    note_front_camera: 'QR 코드를 스캔할 때 전면 카메라가 사용됩니다.',
    scan_code_title: '시작하려면 QR 코드 스캔하세요',
    scan_code_hint: '상자에 QR코드를 넣어주세요',
    scan_code_processing: 'QR 스캔 코드 처리 중...',
    scan_code_logging_in: '계정에 로그인하는 중...',
    scan_code_connect_to_scanner: '인체측정기에 연결하는 중...',
    scan_code_no_account: '계정이 존재하지 않습니다. 다시 시도해 주세요.',
    scan_code_done: '측정준비 완료',
    no_scanner_id: '이 Scanatic™ 계정에 대한 스캐너 ID 설정이 없습니다.',
    no_scanner_found: '지정된 측정기를 찾을 수 없습니다',
    scanner_in_use: '인체측정기가 사용 중입니다',
    unexpected_error: '문제가 발생했습니다 :(',
    need_camera_permission: '이 기능을 사용하려면 카메라 권한을 부여해야 합니다.',
  },
  choose: {
    step_name: '3D 인체측정 준비',
    step_info: '준비가 되면<br>주먹을 원중앙 안으로 들어 올리세요.',
    tutorial: '측정 안내',
    start_scan: '3D 인체측정',
    clench_fingers: '손을 가볍게 쥐어주세요',
    raise_arm: '팔을 들어 원 중앙에 <br>주먹을 넣어주세요',
    hold_til_fill: '이제 원이 채워질 때까지 기다리십시오.',
  },
  thingstonote: {
    title: '3D 인체 측정 전',
    wear_tight: '옷이 몸에 꼭 맞게 입으세요',
    tie_hair: '뒷목 보이도록 머리를 묶으세요',
    remove_acc: '모든 액세서리를 제거해주세요',
  },
  scanscreen: {
    skip: '건너뛰기',
  },
  tutorial: {
    title: '비접촉 제어 튜토리얼',
    contactless: '비접촉식 경험으로 건강이 보호됩니다.',
    clench_fingers: '손을 가볍게 쥐어주세요',
    raise_arm: '원을 조절하려면 원중앙 안으로 팔을 들어 올리고 2초 동안 유지하세요.',
    hold: '이제 원이 채워질 때까지 기다리십시오.',
    proceed: '다음 단계로 진행하려면 원중앙에 오른팔을 들어 올리십시오.',
    return: '이전 단계로 돌아가려면 왼팔이 원 안으로 들어올때까지 올립니다.',
    feet_pos: '바닥 매트의 발사이즈에 맞게 <br>발을 올려주세요.',
  },
  scan: {
    feet_pos: '바닥 매트의 발사이즈에 맞게 <br>발을 올려주세요.',
    step_name: '3D 인체측정',
    phase_one_done: '1단계 완료',
    begin_2nd: '두 번째 포즈 3D 인체 스캔 시작',
    clench: '손을 가볍게 쥐어주세요',
    raise_both_arm: '팔을 들어 원 중앙에 <br>주먹을 넣어주세요',
    raise_fists: '주먹을 들어오려 원중앙 안에 넣어주세요',
    lower_fists: '주먹을 살짝 내려 원 중앙에 주먹을 넣어주세요',
    hold_still: '팔을 움직이지 마세요',
    scan_keep_still: '숨을 참고 몸을 움직이지 마세요',
    scan_in_progress: '3D 인체측정이 진행 중입니다',
    scan_complete: '인체측정이 완료되었습니다. <br>몸의 긴장을 풀 수 있습니다.',
    two_step_scan: '인체측정은 2단계로 진행됩니다',
    scanner_occupied: '인체측정실이 사용 중입니다. 인체측정기를 재설정하고 다시 시도하려면 직원에게 문의하십시오.',
    scanner_error_need_reset: '인체측정기 오류입니다. 인체측정기를 재설정하고 다시 시도하려면 직원에게 문의하십시오.',
    scanner_error_generic: '인체측정기 오류입니다. 직원에게 문의하십시오.',
    scanner_not_activated: '인체측정기가 활성화되지 않았습니다. 직원에게 문의하십시오.',
    scanner_check_network: '인체측정기가 인터넷에 연결되어 있는지 확인하거나 인체측정기를 재설정하고 다시 시도하려면 직원에게 문의하십시오.',
  },
  handles: {
    hold: '손잡이를 잡습니다.<br>팔에 긴장을 풀고 펴십시오.',
    hold_ready: '손잡이를 잡으십시오.<br>이제 준비가 되었습니다.',
    letgo_and_keep_feet: '핸들을 풀고 원래 서 있는 위치를 유지하고 정면을 바라보십시오.',
    clench_ipose: '양손으로 주먹을 가볍게 쥐고<br> 몸에서 약 5 cm 벌리세요.',
    clench_ready: '양손으로 주먹을 가볍게 쥐어주세요<br>인체측정 준비 완료되었습니다.',
  },
  end: {
    thank: '감사합니다 !',
    belonging: '감사합니다 퇴실시 개인소지품을 꼭 챙기세요',
  },
  analyzing: {
    check_err: '3D 형상을 만드는 중입니다…',
  },
  result: {
    scan_successful: '수고하셨습니다! 3D 인체측정이 성공했습니다.',
    scan_unsuccessful: '문제가 발생하여 귀하의 데이터를 <br>처리할 수 없습니다.',
    avoid_errors: '스캔 오류의 일반적인 원인',
    error_accessories: '액세서리 착용',
    error_cover_neck: '목을 덮는 머리카락',
    error_floor_marks: '잘못된 위치에 있는 발',
    error_postural: '잘못된 자세',
    leave: '나가기',
    raise: '다시 측정하려면 원중앙에  주먹을 들어 올리세요.',
    scan_again: '다시 측정',
    analyzing: '3D 형상이 거의 완성되었습니다',
    click_scan_again: '다시 측정하려면 아래 버튼을 클릭하세요.',
    oops: '앗!',
    unexpected_error: '문제가 발생했습니다...',
    close: '닫기',
  },
  measurement: {
    neck: '목둘레',
    chest: '가슴둘레',
    torso: '몸통',
    mid_waist: '허리둘레',
    hip: '엉덩이둘레',
    shoulder: '어깨길이',
    biceps: '팔둘레',
    arm: '팔길이',
    thigh: '허벅지둘레',
    inner_leg: '안쪽 다리 길이',
    chest_female: '밑가슴둘레',
  },
  homePage: {
    firstScanTitle: '3D 인체측정실에 오신 것을 환영합니다',
    tap_to_scan: '버튼 클릭하여 3D 측정 시작하기',
    measurement: '측정 결과',
    body_3d_avatar: '3D 인체',
    see_more: '더보기',
    menu: '메인 메뉴',
    store_settings: '판매자 설정',
    avatar_shader_3d: '3D 아바타 텍스처',
    avatar_shader: '아바타 셰이더',
    create_3d_shader: '3D 셰이더 만들기',
    language: '언어',
    get_help: '도움 받기',
    feedback: '피드백',
    send_feedback: '피드백 보내기',
    send_btn: '보내기',
    send_feedback_placeholder: '귀하의 피드백은 제품 및 서비스를 개선하는 데 도움이 됩니다.',
    send_feedback_title: '귀하의 의견에 감사드립니다',
    send_feedback_content: "보내주신 의견을 참고하여 앞으로 더 나은 경험을 제공할 수 있도록 노력하겠습니다. 더 하실 말씀이 있으시면 주저하지 마시고 연락주세요!",
    report_crash: '충돌 보고',
    report_crash_title: '알려주셔서 감사합니다.',
    report_crash_content: "불쾌한 경험을 드려 죄송합니다. 저희 개발팀에서 최대한 빨리 문제의 원인을 조사하여 해결하도록 노력하겠습니다. 다른 문제가 발생하면 언제든지 저희에게 연락하십시오.",
    rate_app: '나는 Cloudzet 앱을 사랑합니다',
    rate_app_title: 'Cloudzet 앱 평가',
    rate_app_content: '저희 앱이 마음에 드시면 잠시 시간을 내어 App Store에서 평가하거나 검토해 주십시오. 고맙습니다!',
    login_s4f: 'Scanatic™ 계정으로 로그인',
    login: '로그인',
    password: '비밀번호',
    account_settings: '계정 설정',
    enter_Scanatic_account: 'Scanatic™ 계정 번호 입력',
    logout: '로그아웃',
    delete_account: '계정 삭제',
    confirm_delete: '확실합니까?',
    contactless_scan: '터치가 필요 없는 센서 스캔',
    delete: '삭제',
    cancel_delete: '취소',
    ok: '확인',
    scan_to_login: 'QR 코드 스캔',
    history: '기록',
    view_avatar: '3D 아바타 보기',
  },
  settingUserData: {
    your_birth: '당신의 출생 연도?',
    your_gender: '당신의 성별?',
    female: '여성',
    male: '남성',
    tall: '당신의 키?',
    cm: 'cm',
    ft: '피트',
    inch: 'inch',
    your_height: '키',
    your_weight: '당신의 몸무게?',
    weight: '몸무게',
    lbs: 'Lbs',
    kg: 'Kg',
    nickname: '당신의 이름',
    metric: 'cm/kg',
    imperial: 'ft/lbs',
  },
  profile: {
    profile: '프로필',
    edit_profile: '프로필 수정',
    name: '이름',
    birthday: '생년월일',
    birthyear: '출생연도',
    phone: '전화번호',
    address: '주소',
    save: '확인',
    file_size_exceed: '파일 크기는 1MB를 초과할 수 없습니다.',
  },
  discovery: {
    turn_on_bt: '블루투스 켜기',
    turn_on_bt_hint: 'Bluetooth를 허용하고 활성화하기',
    turn_on_bt_hint_ios: "다음 설정이 완료되었는지 확인하세요:<br>1. 권한 부여<br>　● 설정 > 개인 정보 보호 및 보안 > Bluetooth로 이동하여 Cloudzet에 대한 액세스를 허용하세요.<br>2. 블루투스 켜기<br>　● 설정 > Bluetooth로 이동하여 켜세요.",
    turn_on_bt_hint_android: "다음 설정이 완료되었는지 확인하세요:<br>1. 블루투스 켜기<br>　● 화면 상단에서 아래로 스와이프한 후 Bluetooth를 탭하세요.",
    searching: '주변 인체측정기 검색 중...',
    select_scanner: '측정실 준비중입니다<br>잠시만 기다려주세요',
    scanner__foot: '발 측정기',
    scanner__body: '3D 인체측정기',
    start_scan: '3D 인체 측정 시작',
    no_scanners: "주변에 인체 측정기를 찾을 수 없습니다",
    try_again: '다시 시도하십시오',
    scanner_is_busy_title: '스캐너가 사용 중입니다',
    scanner_is_busy_desc: '스캐너를 사용하는 사람이 있는지 확인하십시오.',
    scanner_is_busy_force_release: '지금 스캔',
    scanner_is_busy_wait: '스캔을 기다리십시오',
  },
  footscan: {
    take_off: '발 측정을 시작하려면 먼저 신발을 벗으십시오.',
    barefoot: '꼭 맞는 양말을 신거나 맨발로 가십시오.',
    show_ankles: '바지를 걷어 발목 들어내세요',
    sit: '무릎을 90도 각도로 구부린 상태로 앉아 주세요',
    stand_up: '일어 서세요',
    position_feet: '바닥에 표시된 영역에 발을 놓습니다.',
    start_scan: '측정 시작합니다',
    ready_to_scan: '준비 완료되었습니다',
    stand_up_for_2nd_scan: '일어서서 자연스러운 선 자세를 유지하고 정면을 바라보고 스캔하십시오.',
    stand_still: '몸을 움직이지 않고 정면을 바라보십시오.',
    scan_complete: '스캔 완료<br> 몸의 긴장을 풀어주세요',
    creating_3d_foot: '3D 모델을 생성중입니다...',
    scan_successful: '수고하셨습니다!<br>3D 측정에 성공했습니다.',
    click_to_rescan: '다시 측정하려면 버튼을 누르십시오.',
    feet_3d: '3D 발 측정',
    analysis: '발 분석',
    initial_l: 'L',
    initial_r: 'R',
    tab__fit: '신발 사이즈',
    tab__width: '발 너비',
    tab__arches: '발 아치',
    tab__measure: '발 크기',
    tab__type: '발 유형',
    shoes_guide: '신발 사이즈 추천',
    shoes_last: '마지막 너비',
    measurement__ball: '볼 둘레',
    measurement__foot_length: '발길이',
    measurement__foot_width: '발 너비',
    measurement__instep: '발목 수직 둘레',
    measurement__span: '발 폭',
    measurement__arch: '아치',
    measurement__finger_shape: '발 유형',
    arch_type__title: '내 발 유형',
    arch_type__high: '높은 아치',
    arch_type__summary_high: '서 있어도 요족의 아치가 높게 나타납니다. 또한 다음 증상 중 하나 이상이 나타날 수 있습니다.',
    arch_type__desc_high: '"• Hammertoes(굽은 발가락) 또는 발톱 발톱.<br>' +
      '• 발의 볼, 측면 또는 발뒤꿈치의 굳은살.<br>' +
      '• 서거나 걸을 때 통증이 있습니다.<br>' +
      '• 발뒤꿈치가 안쪽으로 기울어져 발목 염좌로 이어질 수 있는 불안정한 발.<br>' +
      '<br>' +
      '추천 신발 종류:<br>' +
      '구조화된 쿠셔닝으로 충격흡수력이 높은 신발에 적합합니다. 밑창의 경도는 너무 두껍거나 너무 얇지 않은 45도 정도여야 합니다. 높은 아치형 안창을 삽입하여 아치를 지지하고 체중을 발 전체에 고르게 분산시켜 다리에 가해지는 충격을 줄여줍니다."',
    arch_type__normal: '정상 아치',
    arch_type__summary_normal: '아치의 중간 부분이 절반 정도 채워져 있으면 정상적인 아치가 있음을 의미합니다.',
    arch_type__desc_normal: '"정상적인 아치를 갖게 된 것을 축하합니다. 정상적인 운동 루틴과 체중을 유지하십시오. 걱정할 필요가 없습니다.<br>' +
      '<br>' +
      '추천 신발 종류:<br>' +
      '체중이 발 전체에 고르게 분산되기 때문에 모든 종류의 신발에 적합합니다."',
    arch_type__low: '낮은 아치',
    arch_type__summary_low: '요족의 아치는 낮거나 평평해 보이며, 이는 서 있을 때 발바닥 전체가 지면에 닿는 것을 의미합니다. 또한 다음 증상 중 하나 이상이 나타날 수 있습니다.',
    arch_type__desc_low: '"특히 아치나 발꿈치 부위에서 오래 걷거나 서 있는 자세를 할 때 통증이 있습니다.<br>' +
      '- 걷거나 뛸 때 넘어지기 쉽습니다.<br>' +
      '- 체중의 고르지 못한 분포로 인해 서 있는 자세가 불안정해지고 신발 안쪽이 더 빨리 닳게 됩니다.<br>' +
      '<br>' +
      '                                                                                                                                                                                                                                                                추천 신발 종류:<br>' +
      '발목의 염좌를 방지할 수 있도록 아치에 높은 지지력을 제공하는 신발이나 밑창. 밑창의 경도는 V294 정도가 적당하며 부드럽지 않고 구조적이며 안정적입니다. 신발 너비는 발이 움직일 수 있도록 유연해야 합니다. 뒤꿈치 부분이 꼭 맞고 꼭 맞아야 합니다."',
    foot_type__title: '당신의 발 유형',
    foot_type__egyptian: '이집트 발',
    foot_type__summary_egyptian: '엄지발가락에서 새끼발가락으로 갈수록 발가락의 길이가 줄어듭니다.',
    foot_type__desc_egyptian: '"이집트 발은 가장 일반적인 발 유형입니다. 왜냐하면 발가락이 순서대로 배열되어 있기 때문에 일반적으로 다음과 같이 알려져 있습니다.<br>' +
      '둥근 발가락이나 비스듬한 발가락에 좋습니다.<br>' +
      '그러나 뾰족한 신발을 신는 것은 적합하지 않습니다. 가장 긴 엄지 발가락은 뾰족한 신발에 쉽게 눌려 엄지 외반을 유발하기 때문입니다.<br>' +
      '<br>' +
      '신발 제안:<br>' +
      '둥근 발가락 신발, 사선 발가락 신발"',
    foot_type__roman: '로마 발',
    foot_type__summary_roman: '처음 3개의 발가락은 길이가 같고 나머지 2개는 더 짧습니다.',
    foot_type__desc_roman: '"이 발가락 모양은 처음 세 개의 발가락은 높이가 같고 나머지 두 개는 길이가 아래로 내려가는 것이 특징입니다. 이 발가락 유형을 가진 사람들은 균형 잡힌 체형과 성격을 가진 것으로 알려져 있습니다.<br>' +
      '<br>' +
      '추천 신발 종류:<br>' +
      '모든 발가락이 여유 있고 서로 압박되지 않도록 넓은 모양의 신발에 적합합니다."',
    foot_type__greek: '그리스 발',
    foot_type__summary_greek: '둘째 발가락은 엄지발가락을 포함하여 나머지 발가락보다 더 많이 돌출되어 있습니다.',
    foot_type__desc_greek: '"두 번째 발가락이 나머지 발가락보다 길고 다른 발가락의 길이는 발 옆으로 갈수록 짧아지기 때문에 발가락이 형성됩니다. 고대 그리스인들은 발가락이 아릿하다고 해서 그리스 발이라고 불렀습니다. 흥미로운 사실: 많은 그리스 고대 동상과 자유의 여신상은 모두 그리스 발가락을 가지고 있습니다.<br>' +
      '<br>' +
      '추천 신발 종류:<br>' +
      '둥근 발가락 신발, 비스듬한 발가락 신발, 발가락을 밟지 않는 신발을 착용하는 것이 좋습니다. 두 번째 발가락에 체중이 실리기 때문에 부드럽고 유연한 지지력이 있는 앞발 쿠션이 있는 신발이 더 적합합니다."',
    foot_type__unknown: '알 수 없음',
    foot_type__summary_unknown: '알 수 없음',
    foot_type__desc_unknown: '알 수 없음',
  },
  mobileScan: {
    mobile_scan: '모바일 측정',
    body_scanner: '인체 측정기',
    data_processing: '3D 형상이 거의 완성되었습니다',
    comeback_later: '5~10분 후에 돌아와서 3D 결과를 검토하세요.',
    data_process_failed: '귀하의 데이터를 처리할 수 없습니다.',
    error_not_inscreen: '머리부터 발끝까지 전신이 사진에 완전히 나오지 않습니다',
    error_messy_background: '배경이 너무 어수선합니다',
    device_unsupported: '죄송합니다!<br>귀하의 기기는 휴대전화 3D 스캔을 지원하지 않습니다.',
    need_faceid: '앗! <br>귀하의 기기는 현재 3D 휴대전화 스캔을 지원하지 않습니다.',
    scanner_name: '3D 모바일 측정',
    begin_title: '측정준비 하세요',
    begin_info: '옷이 몸에 꼭 맞게 입고<br>뒷목이 보이도록 머리를 묶으십시오',
    start_tutorial: '튜토리얼 시작',
    not_first: '모바일 측정을 해보셨나요?',
    skip_tutorial: '튜토리얼 건너뛰기',
    vertical_info: '평평한 표면에<br>90° 각도로 똑바로 세워 휴대전화를 놓으세요.<br>',
    inscreen_info: '머리부터 발끝까지<br>몸 전체가<br>프레임에 나타나는지 확인하십시오.',
    backoff_info: '다음을 누른 후<br>10초 이내에 돌아가십시오.<br>',
    spin_info: '측정할 때 양손으로 주먹을 쥐고<br>팔을 벌리고 10초 이내에 제자리에서 <br>360도 회전하세요.',
    check_title: '측정준비가 완료되었습니다.',
    check_info: '다음 안내사항이 충족되는지 확인하고 체크해주세요.',
    wear_tight: '몸에 꼭 맞는 옷을 입고 머리를 묶으십시오',
    wipe_front: '전면 카메라 렌즈 청소',
    volume_up: '볼륨을 높여주세요',
    next: '다음 단계',
    start_scan: '측정준비가',
    starting_in: '시작 예정',
    preview_info: '스캔한 데이터가 다음 지침을 준수하는지 확인하고 체크하십시오.',
    preview_inscreen: '사진 속 전신',
    preview_arms_open: '팔을 벌려주세요',
    preview_spin: '제자리에서 360° 회전',
    rescan: '다시 측정',
    uploading: '데이터 처리 중...<br>창을 닫지 마십시오',
    uploading_done: '분석 완료! <br>3D 결과을 다시 확인하려면 5-10분 정도 기다리세요',
    finish_btn: '끝',
    upload_error: 'The mobile 3D body scan function isn\'t enabled<br>Please contact your selected store for more information',
    no_balance: 'The mobile 3D body scan function is suspended<br>Please contact your selected store for more information',
    scan_limit_reached: 'You have reached your scanning limits for this month<br>(each scan account is capped at 3 times per month)',
    leave: 'Leave',
  },
  mobileScan2: {
    inscreen_front_info: 'Make sure your entire body is visible on the screen with arms and lets slightly apart',
    inscreen_side_info: 'For the side photo, Please turn left. Keep your feet together and place both hands against the outside of your thighs',
    inscreen_info: 'Make sure your entire body is visible on the screen',
    trun_left_info: 'Turn left, place hands against the outside of thighs, keep feet together',
  },
  share: {
    voucher_expired: '세션이 만료되었습니다.<br>페이지를 새로고침해 주세요.',
    no_scan_data: '스캔 결과를 찾을 수 없습니다.',
  },
};
